module.exports = __webpack_public_path__ + "img/pump-0.5ac04b82.svg";